import React from "react";
import round from "lodash/round";
import convert from "convert-units";

const UNITS = {
  metric: "kg",
  imperial: "lb",
};

const RPE_INTENSITY_COLORS = [
  "#2787F5",
  "#5BC500",
  "#FFD400",
  "#FF8800",
  "#ED0A34",
  "#FFFFFF",
];

const WeekDailyStats = ({ activeUser, dailyStats }) => {
  const unit = activeUser.units;
  let sessionRPE,
    readinessRate,
    intensityColor,
    bodyWeight = null,
    stepCount = null;

  if (dailyStats) {
    sessionRPE = dailyStats.sessionRPE || null;

    intensityColor = sessionRPE
      ? RPE_INTENSITY_COLORS[Math.trunc(sessionRPE - 5)]
      : null;

    readinessRate = dailyStats.readiness
      ? Object.values(dailyStats.readiness).reduce((a, b) => a + b, 0)
      : null;

    bodyWeight = dailyStats.bodyWeight
      ? unit === "metric"
        ? dailyStats.bodyWeight
        : round(convert(dailyStats.bodyWeight).from("kg").to("lb"), 1)
      : null;
    stepCount = Number(dailyStats.steps) || null;
  }

  const RPEStyle = intensityColor ? { color: intensityColor } : {};
  return (
    <div className="daily-stats-wrapper">
      <div className="stat">
        <p className="p1">Readiness rate</p>
        <p className="clipped">
          {readinessRate ? `${readinessRate} / 25` : "--"}
        </p>
      </div>
      <div className="stat">
        <p className="p1">Session RPE</p>
        <p className="clipped" style={RPEStyle}>
          {sessionRPE ? sessionRPE : "--"}
        </p>
      </div>
      <div className="stat">
        <p className="p1">Bodyweight</p>
        <p className="clipped">
          {bodyWeight ? `${round(bodyWeight, 1)}${UNITS[unit]}` : "--"}
        </p>
      </div>
      <div className="stat">
        <p className="p1">Step count</p>
        <p className="clipped">{stepCount ? stepCount : "--"}</p>
      </div>
    </div>
  );
};

export default WeekDailyStats;
